/** The id of the app shell's `<main>`: the skip link's target. */
export const MAIN_CONTENT_ID = "main-content";

/**
 * Move focus to the page content. The shell's `<main>` is focusable from
 * script only (`tabIndex={-1}`), so a screen reader announces the new page
 * after the phone's sheet or the account menu opened it, instead of focus
 * falling back to the page's top.
 */
export function focusMainContent(): void {
  document.getElementById(MAIN_CONTENT_ID)?.focus();
}
